import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { useIsLoggedIn } from 'hooks/use-is-logged-in';
import { UseQueryOptions, UseQueryResult } from 'react-query';
import { SupplierStatementDto } from './use-get-supplier-statements-api';

const endpoint = 'ums/v1/cms/bnpl/supplier-statements';
export const getSupplierStatementEndpointIdentifier = endpoint;

interface ResponseData {
  data: SupplierStatementDto;
}

type TData = ResponseData;
type TError = AxiosError;
type TQueryKey = [string, number | string];
type Options = Omit<UseQueryOptions<unknown, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;
type ReturnType = UseQueryResult<TData, TError>;

export function useGetSupplierStatementApi(statementId: number | string, options?: Options): ReturnType {
  const toast = useCustomToast();
  const isLoggedIn = useIsLoggedIn();

  const queryFn = async () => {
    try {
      const { data } = await http.get(`${endpoint}/${statementId}`);
      return data;
    } catch (error: any) {
      if (!error.response?.status || !error.response?.data?.message) throw error;
      toast({ description: error.response.data.message, status: 'error' });
      throw error;
    }
  };

  return useQueryWrapper([`${endpoint}/detail`, statementId], queryFn, {
    enabled: isLoggedIn && !!statementId,
    ...options,
  });
}
